import IAdminState from "@/types/admin";

const mutations = {
  SET_ADMIN_STATE: (state: IAdminState, payload: IAdminState): void => {
    Object.keys(payload).forEach((key) => {
      return (state[key] = payload[key]);
    });
  },
  SET_ADMIN_JWT: (state: IAdminState, payload: string): void => {
    state.jwt = payload;
  },
};

export default mutations;
